// Patient-portal v2 PersonIdentity client (PLAN §3.6).
//
// Backend: in.aumhum.aumhum.patient.controller.MeIdentitiesController.
// Endpoints are profile-agnostic — they operate at the user level across
// every patient the user is linked to.

import { shouldUseMocks } from './mockApi'
import { patientGet, patientPost } from './patientApi'

const BASE = '/api/secure/me/identities'
const NO_CONTEXT = { requirePatientContext: false }

function unwrap(res) {
  return res?.data
}

/** GET /me/identities — already-merged groupings + un-merged singletons. */
export async function listIdentities() {
  if (shouldUseMocks()) return []
  const res = await patientGet(BASE, NO_CONTEXT)
  return unwrap(res) || []
}

/**
 * POST /me/identities/merge — confirm a grouping. Body:
 *   { profileIds: ["PAT-...", "PAT-..."], displayName?, dob?, gender?, identityId? }
 * If identityId is omitted, a new PersonIdentity is created.
 */
export async function mergeIdentity(body) {
  if (shouldUseMocks()) return null
  const res = await patientPost(`${BASE}/merge`, body, NO_CONTEXT)
  return unwrap(res)
}

/**
 * POST /me/identities/:identityId/unmerge — split one profile out of an
 * existing grouping. Body: { profileId }.
 */
export async function unmergeIdentity(identityId, body) {
  if (shouldUseMocks()) return null
  const res = await patientPost(
    `${BASE}/${encodeURIComponent(identityId)}/unmerge`,
    body,
    NO_CONTEXT,
  )
  return unwrap(res)
}
